import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaBox, FaTags, FaShoppingBag, FaUsers, FaTools } from 'react-icons/fa';
import './AdminNav.css';

const AdminNav = () => {
  const location = useLocation();

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: <FaHome /> },
    { path: '/admin/products', label: 'Products', icon: <FaBox /> },
    { path: '/admin/categories', label: 'Categories', icon: <FaTags /> },
    { path: '/admin/orders', label: 'Orders', icon: <FaShoppingBag /> },
    { path: '/admin/repairs', label: 'Repairs', icon: <FaTools /> },
    { path: '/admin/users', label: 'Users', icon: <FaUsers /> }
  ];

  return (
    <nav className="admin-nav">
      <div className="container">
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default AdminNav;
